import React, {useRef, useState, useEffect} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import classNames from "classnames";
import Slider from "react-slick";
import Grid from "@material-ui/core/Grid";
import View from "../View";
import EditButton from "../EditButton";
import Loader from "../../../common/LoaderModule";
import ThreeDButton from "../ThreeDButton";
import ZoomableImage from "../ZoomableImage";
import RasterizingMessage from "../RasterizingMessage";
import {
  viewsSelector,
  editPathSelector,
  productLoadingSelector,
  productReadySelector,
  getViews,
  productBannedSelector,
  singularSelector
} from "../../ducks/product";
import withErrorBoundary from "../../../../decorators/withErrorBoundary";
import allCustomViews from "../../../../mocks/products-custom-views";

import styles from "./views.module.scss";

function Views(props) {
  const {
    views: {
      large: largeViews,
      small: smallViews,
      detailed: detailedViews,
      defaultSide,
      alt: viewAlt,
      title: viewTitle
    },
    editPath,
    loading,
    ready,
    banned,
    singular,
    getViews: getViewsAC
  } = props;
  const [activeIndex, setActiveIndex] = useState(defaultSide);
  const sliderRef = useRef(null);
  const handleClick = (index) => (event) => {
    event.preventDefault();
    sliderRef.current.slickGoTo(index);
    setActiveIndex(index);
  };
  useEffect(() => {
    if (!ready) {
      getViewsAC();
    }
  }, [getViewsAC, ready]);

  const customViews = allCustomViews[singular];
  const customSmallViews = customViews ? customViews.map((item) => item.smallView) : [];
  const customLargeViews = customViews ? customViews.map((item) => item.largeView) : [];

  const hasSmallViews = smallViews && (smallViews.length > 1 || (smallViews.length + customSmallViews.length) > 1);

  return (
    <Grid
      container
      className={classNames(
        styles.root,
        (loading || !ready) && styles.rootLoading
      )}
    >
      <Grid item lg={2} md={2} className={styles.navigation}>
        <div className={styles.smallViews}>
          {hasSmallViews && [...smallViews, ...customSmallViews].map((view, i) => (
            <button
              key={i}
              onClick={handleClick(i)}
              className={classNames(
                  styles.smallView,
                  i === activeIndex ? styles.smallViewActive : ``
              )}
            >
              <View src={view} alt={viewAlt} title={viewTitle}/>
            </button>
          ))}
        </div>
        <EditButton className={styles.editButton} path={editPath} />
        <ThreeDButton className={styles.threeDButton} />
      </Grid>
      <Grid item lg={10} md={10} sm={12} xs={12} className={styles.main}>
        {loading && <Loader className={styles.loader} />}
        {!ready && <RasterizingMessage className={styles.rasterizingMessage} />}
        <Slider
          ref={sliderRef}
          initialSlide={defaultSide}
          arrows={false}
          speed={500}
          dots={false}
          draggable={false}
          responsive={[
            {
              breakpoint: 940,
              settings: {
                dots: true
              }
            }
          ]}
        >
          {largeViews &&
            largeViews.map((view, i) => (
              <ZoomableImage
                key={i}
                smallImage={view}
                largeImage={detailedViews[i]}
                alt={viewAlt}
                title={viewTitle}
                className={styles.largeSlide}
                isDisabled={banned}
              />
            ))}
          {customLargeViews.length > 0 && customLargeViews.map((view, i) => (
            <ZoomableImage
              key={i}
              smallImage={view}
              largeImage={view}
              alt={viewAlt}
              title={viewTitle}
              className={styles.largeSlide}
              isDisabled={banned}
            />
          ))}
        </Slider>
        <div id="portal" className={styles.portal} />
      </Grid>
    </Grid>
  );
}

Views.propTypes = {
  views: PropTypes.object,
  width: PropTypes.string,
  editPath: PropTypes.string,
  loading: PropTypes.bool,
  getViews: PropTypes.func,
  ready: PropTypes.bool,
  singular: PropTypes.string,
  banned: PropTypes.bool
};

const mapStateToProps = (state) => ({
  views: viewsSelector(state),
  editPath: editPathSelector(state),
  loading: productLoadingSelector(state),
  ready: productReadySelector(state),
  singular: singularSelector(state),
  banned: productBannedSelector(state)
});

const mapDispatchToProps = {
  getViews
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorBoundary(Views));
